export const commentsTranslationMap: Record<string, string> = {
  "# Initialize the SDK. Set verbose to True if you want verbose logging.": "snippets.python.init",
  "# Login using your valid konan credentials": "snippets.python.login",
  "# Alternative printing with better formatting": "snippets.python.predict.altHeader",
} as const
